import styled, { css } from "styled-components";

const FormGroupStyled = styled.div`
    position: relative;
    margin: 1.6rem 0;

    &.half{
        width:50%;
    }

	&.toggle {
		margin: 2.4rem 0;

		@media only screen and (min-width: ${props => props.theme.tablet}) {
			margin: 2.4rem 0;

			&:last-of-type {
				margin-bottom: 0;
			}

			&:first-of-type {
				margin-top: 4rem;
			}
		}
	}

    &.form__two-fields {
        display: flex;
        flex-wrap: wrap;

        @media only screen and (min-width: ${props => props.theme.tablet}) {
            flex-wrap: nowrap;
            justify-content: space-between;
        }

        & > div {
            margin-top: 0;
            width: 100%;
            @media only screen and (min-width: ${props => props.theme.tablet}) {
                width: calc(50% - 1rem);
                margin-bottom: 0;
            }
        }
    }

    &.form__three-fields {
        display: flex;
        flex-wrap: wrap;

        @media only screen and (min-width: ${props => props.theme.tablet}) {
            flex-wrap: nowrap;
            justify-content: space-between;
        }

        & > div {
            margin-bottom: 0;
            margin-top: 0;
            width: 100%;
            @media only screen and (min-width: ${props => props.theme.tablet}) {
                width: calc(33% - 1rem);
            }
        }
    }

    &.form__mobile-fields {

        display: flex;
        flex-wrap: wrap;

        @media only screen and (min-width: ${props => props.theme.tablet}) {
            flex-wrap: nowrap;
            justify-content: space-between;
        }
        & > div {
            margin-bottom: 0;
            &:nth-of-type(1) {
                width: calc(66% - 1rem);
                margin-right: 1rem;

                @media only screen and (min-width: ${props => props.theme.tablet}) {
                    width: calc(50% - 1rem);
                }
            }

            &:nth-of-type(2) {
                width: 34%;

                @media only screen and (min-width: ${props => props.theme.tablet}) {
                    margin-right: 1rem;
                    width: calc(23% - 1rem);
                }
            }

            &:nth-of-type(3) {
                width: 100%;
                margin-bottom: 2.5rem;
                @media only screen and (min-width: ${props => props.theme.tablet}) {
                    width: 38.5%;
                }
            }
        }
    }

    &.form__textarea {
        label {
            top: 2.5rem;
        }
    }

    /* focused */
    ${props => {
        return (
            props.focused &&
            css`
                label {
                    font-size: 1.2rem;
                    top: 2rem;
                    font-weight: bold;
                }
                input {
                    line-height: normal; /* safari fix */
                    padding-top: 2rem;
                    padding-bottom: 0;
                }
            `
        );
    }}

    /* errors */
    ${props => {
        return (
            props.error &&
            css`
                > div {
                    input,
                    select,
                    textarea {
                        border-color: #d22630;
                    }
                }
            `
        );
    }}

    /* disabled */
    ${props => {
        return (
            props.disabled &&
            css`
                background: ${props.theme.lightGray};
                label {
                    font-size: 1.2rem;
                    top: 1.5rem;
                }
                input {
                    line-height: normal; /* safari fix */
                    padding-top: 2.8rem;
                }
            `
        );
    }}

    /* covert */
    ${props => {
        return (
            props.covert &&
            css`
                input {
                    background: red;
                }
            `
        );
    }}
`;

export default FormGroupStyled;
